export {
  clientCommentsApi,
  useAddClientCommentMutation,
  useDeleteClientCommentMutation,
  useEditClientCommentMutation,
  useUnpinClientCommentMutation,
} from './api';
export {
  ClientCommentsEndpoints,
  type AddClientCommentRequest,
  type AddClientCommentResponse,
  type DeleteClientCommentRequest,
  type DeleteClientCommentResponse,
  type EditClientCommentRequest,
  type EditClientCommentResponse,
  type ModelClientComment,
  type UnpinClientCommentRequest,
  type UnpinClientCommentResponse,
} from './types';
